import { render, staticRenderFns } from "./LocationLink.vue?vue&type=template&id=045e3ea5"
import script from "./LocationLink.vue?vue&type=script&lang=js"
export * from "./LocationLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports